module.exports = __webpack_public_path__ + "static/media/greenCheck.8d26f8cc.svg";